import SpriteSymbol from "../../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/_svg-sprite-loader@5.2.1@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-animate_oval_active",
  "use": "icon-animate_oval_active-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-animate_oval_active\">\n<rect width=\"32\" height=\"32\" rx=\"6\" fill=\"#3663E1\" />\n<ellipse cx=\"16\" cy=\"16\" rx=\"8\" ry=\"5\" stroke=\"white\" stroke-width=\"1.5\" stroke-linecap=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol